import { PageRef } from 'providers/page-ref';

export type UnsubscribePageParams = {};

export const IUnsubscribePage: PageRef<UnsubscribePageParams, void> = {
  pageName: 'UnsubscribePage',
} as PageRef<UnsubscribePageParams, void>;
